export const COORDENADAS = [
  // filtradas
  {
    nome: 'USF CASTELO',
    lat: -23.948655969597233,
    lng: -46.378859589829766
  },
  {
    nome: 'UBS VILA MATHIAS',
    lat: -23.94986450867183,
    lng: -46.324961894342856
  },
  {
    nome: 'UBS MARAPE',
    lat: -23.952380801527806,
    lng: -46.34974688930224
  },
  {
    nome: 'UBS GONZAGA',
    lat: -23.960129346688642,
    lng: -46.33060778563961
  },
  {
    nome: 'USF CARUARA',
    lat: -23.88866980655436,
    lng: -46.189055399998864
  },
  {
    nome: 'USF ESTUARIO',
    lat: -23.970534224204897,
    lng: -46.30218188258747
  },
  {
    nome: 'USF PIRATININGA',
    lat: -23.92516069865887,
    lng: -46.38838778249971
  },
  {
    nome: 'CAPS ORQUIDARIO',
    lat: -23.965265546418568,
    lng: -46.34792012989119
  },
  {
    nome: 'CENTRO DE ATENCAO PSICOSSOCIAL ZONA NOROESTE CAPS ZNO',
    lat: -23.9405310087029,
    lng: -46.37595669746882
  },
  {
    nome: 'USF BOM RETIRO',
    lat: -23.936049899472838,
    lng: -46.37057115023008
  },
  {
    nome: 'UBS APARECIDA',
    lat: -23.971490037337663,
    lng: -46.30827495872207
  },
  {
    nome: 'USF AREIA BRANCA',
    lat: -23.945553091945303,
    lng: -46.37335972250497
  },
  {
    nome: 'USF VILA NOVA',
    lat: -23.9378914040528,
    lng: -46.328092405057475
  },
  {
    nome: 'USF NOVA CINTRA',
    lat: -23.943053498792523,
    lng: -46.35181977779323
  },
  {
    nome: 'USF ALEMOA E CHICO DE PAULA',
    lat: -23.93117499528208,
    lng: -46.35868460978533
  },
  {
    nome: 'USF VILA PROGRESSO',
    lat: -23.939034471212008,
    lng: -46.35291569872289
  },
  {
    nome: 'CENTRO DE ATENCAO PSICOSSOCIAL III DA VILA CAPS DA VILA',
    lat: -23.95817071369301,
    lng: -46.34499981524723
  },
  {
    nome: 'UBS POMPEIA/JOSE MENINO',
    lat: -23.963293507881293,
    lng: -46.341737775222704
  },
  {
    nome: 'UBS CAMPO GRANDE',
    lat: -23.955068012704256,
    lng: -46.34348323129469
  },
  {
    nome: 'UBS EMBARE',
    lat: -23.965351872876845,
    lng: -46.310599296607904
  },
  {
    nome: 'AMBULATORIO DE ESPECIALIDADES NELSON TEIXEIRA',
    lat: -23.958613708854887,
    lng: -46.31862380006187
  },
  {
    nome: 'USF MORRO SAO BENTO',
    lat: -23.937083812831098,
    lng: -46.342338778195334
  },
  {
    nome: 'USF JABAQUARA',
    lat: -23.940787200116358,
    lng: -46.33551170165025
  },
  {
    nome: 'USF SAO MANOEL',
    lat: -23.929615810334692,
    lng: -46.379725156412604
  },
  {
    nome: 'USF MARTINS FONTES',
    lat: -23.945755278537607,
    lng: -46.319208905131966
  },
  {
    nome: 'USF VALONGO',
    lat: -23.930420480318787,
    lng: -46.34177722800046
  },
  {
    nome: 'SEAMBESP ZONA NOROESTE SANTOS',
    lat: -23.943680013079863,
    lng: -46.37667988033745
  },
  {
    nome: 'USF MORRO DA PENHA',
    lat: -23.93148478206371,
    lng: -46.3427929641413
  },
  {
    nome: 'USF MORRO SANTA MARIA',
    lat: -23.93729263305818,
    lng: -46.35916923384224
  },
  {
    nome: 'USF MONTE SERRAT',
    lat: -23.93793601287503,
    lng: -46.32786214457841
  },
  {
    nome: 'CAPS CENTRO',
    lat: -23.95596377065241,
    lng: -46.31653351200402
  },
  {
    nome: 'USF MORRO JOSE MENINO',
    lat: -23.96319076545849,
    lng: -46.357686621978665
  },
  {
    nome: 'UBS RADIO CLUBE',
    lat: -23.94059590952182,
    lng: -46.38219565790921
  },
  {
    nome: 'CENTRO DE ATENCAO PSICOSSOCIAL PRAIA CAPS PRAIA',
    lat: -23.979061037919244,
    lng: -46.30336651725274
  },
  {
    nome: 'UBS PONTA DA PRAIA',
    lat: -23.97837940194696,
    lng: -46.300794127962156
  },
  {
    nome: 'UBS CONSELHEIRO NEBIAS',
    lat: -23.953952114137504,
    lng: -46.32231301028231
  },
  {
    nome: 'USF VILA SAO JORGE E CANELEIRA',
    lat: -23.94565584783224,
    lng: -46.36570039178782
  },
  {
    nome: 'USF MONTE CABRAO',
    lat: -23.919432746967548,
    lng: -46.2860376405012
  }
  // não filtradas
]

export const latLong = unidade => {
  const finder = latitude => latitude.nome === unidade
  return (
    COORDENADAS.find(finder) || {
      nome: 'santos-default',
      lat: -23.857523739574418,
      lng: -46.293318312076764
    }
  )
}

export const latLongGroup = unidades => {
  const filter = coordenada =>
    unidades.find(({ unidade_saude }) => unidade_saude === coordenada.nome)

  return COORDENADAS.filter(filter).map(({ lat, lng, nome: title }) => {
    const { disponivel: available } = unidades.find(
      unidade => unidade.unidade_saude === title
    )

    return {
      position: {
        lat,
        lng
      },
      title,
      available
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/coordenadas-remedios.js